<mat-form-field class="dropdown-field">
  <mat-label>{{label}}</mat-label>
  <input 
      type="text"
      matInput
      #autoInput
      [matAutocomplete]="auto"
      [placeholder]="placeholder"
      [formControl]="formControl"
  >
  <mat-icon matSuffix class="icon" *ngIf="!value && !formValue">arrow_drop_down</mat-icon>
  <button
      matSuffix
      class="icon"
      *ngIf="value || formValue"
      mat-icon-button
      aria-label="Clear"
      (click)="onClear($event)"
  >
      <mat-icon>close</mat-icon>
  </button>
  <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displaySelectedOption"
      (optionSelected)="onSelected($event)"
  >
    <mat-option *ngFor="let option of (filteredOptions | async)" [value]="option">
        {{option.display}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>